module.exports = __webpack_public_path__ + "img/form-bg-1.797e7199.svg";